import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { apiUrl } from "../../config/Config";

const CustomerQuestions = () => {
  const navigate = useNavigate();
  const userdata = useSelector((store) => store.userReducer.userdata);
  const [questions, setQuestions] = useState([]);
  const [selectedQuestionId, setSelectedQuestionId] = useState(null);
  const [replyText, setReplyText] = useState("");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  const selectedQuestion =
    questions.find((question) => String(question.id) === String(selectedQuestionId)) ||
    questions[0] ||
    null;

  const headers = {
    headers: {
      "Content-Type": "application/json",
      Authorization: "Bearer " + userdata?.token,
    },
  };

  const formatDate = (dateValue) => {
    if (!dateValue) return "NA";
    const date = new Date(dateValue);
    if (Number.isNaN(date.getTime())) return dateValue;
    return new Intl.DateTimeFormat("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  };

  const fetchQuestions = async () => {
    setLoading(true);
    await axios
      .post(apiUrl + "getadmincustomerquestions", {}, headers)
      .then((res) => {
        if (res.data.status === "success") {
          const nextQuestions = Array.isArray(res.data.data) ? res.data.data : [];
          setQuestions(nextQuestions);
          setSelectedQuestionId(nextQuestions[0]?.id || null);
          setReplyText(nextQuestions[0]?.admin_reply || "");
        } else {
          Swal.fire({
            text: res.data.message,
            icon: "error",
            confirmButtonColor: "rgb(59, 151, 196)",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: err.message,
          icon: "error",
          confirmButtonColor: "rgb(59, 151, 196)",
        });
      });
    setLoading(false);
  };

  const selectQuestion = (question) => {
    setSelectedQuestionId(question.id);
    setReplyText(question.admin_reply || "");
  };

  const saveReply = async () => {
    if (!selectedQuestion || !replyText.trim()) {
      Swal.fire({
        text: "Please write a reply before submitting",
        icon: "error",
        confirmButtonColor: "rgb(59, 151, 196)",
      });
      return;
    }

    setSaving(true);
    await axios
      .post(
        apiUrl + "replycustomerquestion",
        {
          id: selectedQuestion.id,
          admin_reply: replyText,
        },
        headers
      )
      .then((res) => {
        if (res.data.status === "success") {
          Swal.fire({
            text: "Reply saved successfully",
            icon: "success",
            confirmButtonColor: "rgb(59, 151, 196)",
          });
          fetchQuestions();
        } else {
          Swal.fire({
            text: res.data.message,
            icon: "error",
            confirmButtonColor: "rgb(59, 151, 196)",
          });
        }
      })
      .catch((err) => {
        Swal.fire({
          text: err.message,
          icon: "error",
          confirmButtonColor: "rgb(59, 151, 196)",
        });
      });
    setSaving(false);
  };

  useEffect(() => {
    if (userdata && Object.keys(userdata).length > 0) {
      fetchQuestions();
    } else {
      navigate("/admin/login");
    }
  }, []);

  return (
    <div className="admin-question-page">
      <div className="dashboardbox admin-question-layout">
        <div className="admin-question-list">
          <div className="admin-question-header">
            <div>
              <p className="dashboardboxtitle">Customer Questions</p>
              <span>{questions.length} total</span>
            </div>
          </div>

          {loading ? (
            <p className="admin-question-empty">Loading questions...</p>
          ) : questions.length ? (
            questions.map((question) => (
              <button
                key={question.id}
                className={`admin-question-card ${
                  String(selectedQuestion?.id) === String(question.id) ? "active" : ""
                }`}
                onClick={() => selectQuestion(question)}
              >
                <div>
                  <strong>{question.subject}</strong>
                  <span
                    className="admin-inline-link"
                    onClick={(event) => {
                      event.stopPropagation();
                      question.customer_id && navigate(`/admin/customer-details/${question.customer_id}`);
                    }}
                  >
                    {question.customer_name || "Customer"}
                  </span>
                </div>
                <p>{formatDate(question.created_at)}</p>
                <small className={`admin-question-status ${question.status}`}>
                  {question.status || "open"}
                </small>
              </button>
            ))
          ) : (
            <p className="admin-question-empty">No customer questions yet.</p>
          )}
        </div>

        <div className="admin-question-detail">
          {selectedQuestion ? (
            <>
              <div className="admin-question-detail-head">
                <div>
                  <span>{selectedQuestion.customer_email}</span>
                  <h3>{selectedQuestion.subject}</h3>
                </div>
                <strong className={`admin-question-status ${selectedQuestion.status}`}>
                  {selectedQuestion.status || "open"}
                </strong>
              </div>

              <div className="admin-question-message">
                <label>Customer Message</label>
                <p>{selectedQuestion.message}</p>
              </div>

              <div className="admin-question-reply-box">
                <label>Admin Reply</label>
                <textarea
                  value={replyText}
                  onChange={(event) => setReplyText(event.target.value)}
                  placeholder="Write your response to the customer"
                />
              </div>

              <button className="webcustom-btn admin-question-save" onClick={saveReply}>
                {saving ? "Saving..." : "Save Reply"}
              </button>
            </>
          ) : (
            <p className="admin-question-empty">Select a question to reply.</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CustomerQuestions;
